import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
import FormInputNumber from "../../../../../components/form/FormInputNumber";
import FormSelectOpcDataType from "../../../../../components/form/FormSelectOpcDataType";
// INTERFACES
import {
  GetPropertyResponseInterface,
  DataInterface,
  DataRepresentationInterface,
} from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentGetPropertyResponse({
  data,
  setData,
}: {
  data: GetPropertyResponseInterface;
  setData: (newValue: GetPropertyResponseInterface) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeValue = (newValue: number | string, variableName: string) => {
    const copy = structuredClone(data);
    if (variableName === "description" && typeof newValue === "string") {
      copy.property.description = newValue;
    } else if (variableName === "id" && typeof newValue === "number") {
      copy.property.id = newValue;
    } else if (variableName === "type" && typeof newValue === "number") {
      copy.property.type = newValue;
    }
    setData(copy);
  };

  const parseDataKey = (data_: DataInterface): DataRepresentationInterface => {
    const [dataKey]: any = Object.entries(data_)[0];
    return dataKey;
  };

  const setDataType = (newValue: DataRepresentationInterface) => {
    const copy = structuredClone(data);
    if (newValue === "u16") {
      copy.property.data = { u16: 1 };
    } else if (newValue === "i16") {
      copy.property.data = { i16: 1 };
    } else if (newValue === "u32") {
      copy.property.data = { u32: 1 };
    } else if (newValue === "i32") {
      copy.property.data = { i32: 1 };
    } else if (newValue === "float") {
      copy.property.data = { float: 1 };
    } else if (newValue === "u64") {
      copy.property.data = { u64: 1 };
    } else if (newValue === "i64") {
      copy.property.data = { i64: 1 };
    } else if (newValue === "double") {
      copy.property.data = { double: 1 };
    } else if (newValue === "string") {
      copy.property.data = { string: "" };
    }
    setData(copy);
  };

  const onChangeDataValueNumber = (newValue: number) => {
    const copy = structuredClone(data);
    if (parseDataKey(data.property.data) === "u16") {
      copy.property.data = { u16: newValue };
    } else if (parseDataKey(data.property.data) === "i16") {
      copy.property.data = { i16: newValue };
    } else if (parseDataKey(data.property.data) === "u32") {
      copy.property.data = { u32: newValue };
    } else if (parseDataKey(data.property.data) === "i32") {
      copy.property.data = { i32: newValue };
    } else if (parseDataKey(data.property.data) === "float") {
      copy.property.data = { float: newValue };
    } else if (parseDataKey(data.property.data) === "u64") {
      copy.property.data = { u64: newValue };
    } else if (parseDataKey(data.property.data) === "i64") {
      copy.property.data = { i64: newValue };
    } else if (parseDataKey(data.property.data) === "double") {
      copy.property.data = { double: newValue };
    }
    setData(copy);
  };

  const onChangeDataValueString = (newValue: string) => {
    const copy = structuredClone(data);
    copy.property.data = { string: newValue };
    setData(copy);
  };

  const parseDataValue = (data_: DataInterface) => {
    const [, dataValue] = Object.entries(data_)[0];
    return dataValue;
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <FormSelectOpcDataType
        inputValue={parseDataKey(data.property.data)}
        inputOnChange={setDataType}
        disabledInput={false}
      />
      {parseDataKey(data.property.data) !== "string" && (
        <FormInputNumber
          inputValue={parseDataValue(data.property.data)}
          inputLabelName={t("general.dataValue")}
          inputOnChange={onChangeDataValueNumber}
          inputVariableName=""
        />
      )}
      {parseDataKey(data.property.data) === "string" && (
        <FormInputText
          inputValue={parseDataValue(data.property.data)}
          inputLabelName={t("general.dataValue")}
          inputOnChange={onChangeDataValueString}
          inputVariableName=""
          isRequired
          disabledInput={false}
        />
      )}
      <FormInputText
        inputValue={data.property.description}
        inputLabelName={t("general.description")}
        inputOnChange={onChangeValue}
        inputVariableName="description"
        isRequired
        disabledInput={false}
      />
      <FormInputNumber
        inputValue={data.property.id}
        inputLabelName="ID"
        inputOnChange={onChangeValue}
        inputVariableName="id"
      />
      <FormInputNumber
        inputValue={data.property.type}
        inputLabelName={t("general.type")}
        inputOnChange={onChangeValue}
        inputVariableName="type"
      />
    </div>
  );
}
